import React from 'react';
import { getDateNoTimeZoneFromMiliseconds } from '../../../shared/utils/smartutils';
import { textEllipsis } from '../../../shared/utils/constants';

export default function (t) {
  return [
    { title: t('general.number'), field: 'numberContract' },
    {
      title: t('general.type'),
      field: 'contractType.name',
      cellStyle: textEllipsis,
      render: (rowData) => {
        const { contractType } = rowData;
        return (
          <span className="tooltip-test" title={contractType.name}>
            {contractType.name}
          </span>
        );
      },
    },
    {
      title: t('general.student'),
      field: 'student.fullName',
      cellStyle: textEllipsis,
      render: (rowData) => {
        const { student } = rowData;
        return (
          <span className="tooltip-test" title={student.fullName}>
            {student.fullName}
          </span>
        );
      },
    },
    {
      title: t('general.responsible-account'),
      field: 'responsible1.responsible.fullName',
      cellStyle: textEllipsis,
      render: (rowData) => {
        const { responsible1 } = rowData;
        return (
          <span
            className="tooltip-test"
            title={responsible1.responsible.fullName}
          >
            {responsible1.responsible.fullName}
          </span>
        );
      },
    },
    {
      title: t('general.initial_date'),
      field: 'initialDateFormatted',
      render: (rowData) =>
        getDateNoTimeZoneFromMiliseconds(rowData.initialDate),
    },
    {
      title: t('general.first_expiration_date'),
      field: 'firstExpirationDate',
      render: (rowData) =>
        getDateNoTimeZoneFromMiliseconds(rowData.firstExpirationDate),
    },
    {
      title: t('general.final_date'),
      field: 'finalDateFormatted',
      render: (rowData) =>
        getDateNoTimeZoneFromMiliseconds(
          rowData.finalValidityDate
            ? rowData.finalValidityDate
            : rowData.finalDate
        ),
    },
    { title: t('general.validity'), field: 'validity' },
    {
      title: t('general.validity-term'),
      field: 'validityTerm',
    },
    {
      title: t('general.status'),
      field: 'statusFormatted',
    },
    {
      title: t('general.product-total'),
      field: 'netValue',
      render: (rowData) =>
        rowData.netValue.toLocaleString('pt-br', {
          style: 'currency',
          currency: 'BRL',
        }),
    },
    {
      title: t('general.contract-total'),
      field: 'totalContractValue',
      render: (rowData) =>
        rowData.totalContractValue.toLocaleString('pt-br', {
          style: 'currency',
          currency: 'BRL',
        }),
    },
  ];
}
